export function useWidth(
  attrWidth: number | null | string,
  defaultWidth: number,
  smallMedia: boolean,
  containerSize: number
) {
  containerSize = containerSize ?? Infinity;

  let width = attrWidth ?? defaultWidth;
  let maxWidth = +defaultWidth;
  width = +width;

  if (smallMedia) {
    maxWidth = 500;
  }

  // Keep within bounds
  if (width > containerSize) {
    width = containerSize - 32;
  }

  width = parseInt(`${width}`);

  return { maxWidth, width };
}
